import { State } from 'jumpstate'

export default State({
  initial: {
    isInitial: true,
    isInitialInProgress: false,
    isDirty: true,
    inProgress: 0,
    active: new Set()
  },
  syncActiveAdd (state, payload) {
    if (state.active.has(payload)) return state
    return Object.assign({}, state, {
      active: new Set(state.active.values()).add(payload)
    })
  },
  syncActiveRemove (state, payload) {
    if (!state.active.has(payload)) return state
    const nextState = new Set(state.active.values())
    nextState.delete(payload)
    return Object.assign({}, state, {
      active: nextState
    })
  },
  syncNeeded (state, payload) {
    if (state.isDirty) return state
    return Object.assign({}, state, {
      isDirty: true
    })
  },
  syncBegin (state, payload) {
    return Object.assign({}, state, {
      inProgress: state.inProgress + 1
    })
  },
  syncFailed (state, payload) {
    console.error('syncFailed', payload.error)
    return Object.assign({}, state, {
      isDirty: true,
      inProgress: state.inProgress - 1,
      error: payload.error
    })
  },
  syncInitialEnd (state) {
    return Object.assign({}, state, {
      isInitialInProgress: false,
      isInitial: false
    })
  },
  syncInitialBegin (state) {
    return Object.assign({}, state, {
      isInitialInProgress: true
    })
  },
  syncSuccess (state, payload) {
    return Object.assign({}, state, {
      isDirty: (state.inProgress - 1) === 0,
      inProgress: state.inProgress - 1
    })
  }
})



// WEBPACK FOOTER //
// ../webmango-core/state/sync.js